(function () {
  var tracks = document.querySelectorAll("[data-ahmp-marquee]");
  if (!tracks.length) return;

  var reduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  tracks.forEach(function (track) {
    if (!track.dataset.ahmpDuplicated) {
      track.innerHTML = track.innerHTML + track.innerHTML;
      track.dataset.ahmpDuplicated = "true";
    }

    if (reduced) {
      track.style.animation = "none";
      track.style.transform = "none";
    }
  });
})();
